import { z } from 'zod';
import { TicketStatusFilterSchema } from '@/features/stacktrace/tickets/-constants';
import { TicketPriority, TicketStatus as TST } from '@/features/stacktrace/tickets/-query/type';
import { TicketTableColumns } from './-table/type';

/**
 * チケット 一覧画面の URL search スキーマ（Step G-5g 本実装）。
 *
 * - status:        ステータスタブ用フィルタ（"ALL" + 6 ドメイン値）
 * - productId:     プロダクト絞り込み（単一 ID）
 * - priority:      優先度絞り込み（P0〜P3 単一値）
 * - freeText:      検索バー（title / code 部分一致）
 * - pageIndex:     0-origin ページ番号
 * - pageSize:      1 ページあたりの件数
 * - sortColumn:    ソート対象カラム
 * - orderDirection ソート方向
 */
export const TicketListPageFilterSchema = z.object({
  status: TicketStatusFilterSchema.default(TST.OPEN),
  productId: z.string().optional(),
  priority: z.nativeEnum(TicketPriority).optional(),
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(TicketTableColumns).optional(),
  orderDirection: z.enum(['asc', 'desc']).default('desc')
});